import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, TrainIcon, CarIcon, ExternalLinkIcon } from 'lucide-react';
const MAP_URL = 'https://mapy.com/cs/turisticka?planovani-trasy&rc=9hOj9xXGb0&rs=&rs=coor&ri=&ri=&mrp=%7B%22c%22%3A111%2C%22dt%22%3A%22%22%2C%22d%22%3Atrue%7D&xc=%5B%5D&rut=1&x=14.5184141&y=49.9449350&z=17';
export function LocationSection() {
  return <section id="lokalita" className="py-24 bg-white overflow-hidden" data-id="element-156" data-mp="1s46zcsvrqmc0">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-157" data-mp="1s2chxojphcco">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-158" data-mp="1n5vqolh7mhvd">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-159" data-mp="214lns1414hjq">
            <div className="flex items-center gap-3 text-accent mb-4" data-id="element-160" data-mp="2qtt2y43io89">
              <MapPinIcon className="w-5 h-5" data-id="element-161" data-mp="2mrdexfhsatbz" />
              <span className="font-medium tracking-wider uppercase text-sm" data-id="element-162" data-mp="2moiu3muuz6i1">
                Dolní Jirčany, Praha-západ
              </span>
            </div>
            <h2 className="font-heading text-4xl md:text-5xl text-primary mb-6" data-id="element-163" data-mp="2wnqhl2vb4hiv">
              Lokalita
            </h2>

            <div className="space-y-6 text-base-gray text-lg mb-10" data-id="element-164" data-mp="31h2ska72cpt5">
              <p data-id="element-165" data-mp="36fco4lwp9sfa">
                Projekt se nachází ve strategické a vyhledávané lokalitě, která
                kombinuje klid venkova s výbornou dostupností do metropole.
              </p>
              <ul className="space-y-[5px]" data-id="element-166" data-mp="3fezs9fgtdcc1">
                <li className="flex items-start gap-3" data-id="element-167" data-mp="3fg2f9cb0mumo">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-168" data-mp="3kem7fug7d2nh" />
                  <span data-id="element-169" data-mp="1l1rr7628w4hy">Pražský okruh ca 2 km</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-170" data-mp="1l3l1qwfzb8v8">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-171" data-mp="1q14gdxgl9nnp" />
                  <span data-id="element-172" data-mp="1i0oltadel0wz">Metro Opatov 12 km</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-173" data-mp="1dybjyx1s1n5h">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-174" data-mp="1dzv08nnfny79" />
                  <span data-id="element-175" data-mp="1rze6tc0lj1hg">
                    Nákupní zóna Čestlice / Aquapalace, hypermarkety 13 km
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-176" data-mp="20yhpwfzrjgvy">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-177" data-mp="20wyb6ttr9dwa" />
                  <span data-id="element-178" data-mp="1ww4no1k8613x">Zámek a park Průhonice 15 km</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-179" data-mp="2aokiwg6vwuua">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-180" data-mp="2aq5d24paebrm" />
                  <span data-id="element-181" data-mp="25raw78avqxa5">Autobusové zastávky PID v docházkové vzdálenosti</span>
                </li>
              </ul>

              <div className="pt-4 border-t border-primary/10" data-id="element-182" data-mp="2fndwe8m68lug">
                <h4 className="font-heading text-xl text-base-dark mb-4" data-id="element-183" data-mp="2foys41k82atw">
                  Kompletní občanská vybavenost
                </h4>
                <ul className="space-y-4 text-base" data-id="element-184" data-mp="33aiv37q4vjzw">
                  <li className="flex items-start gap-3" data-id="element-185" data-mp="33a94pj16fato">
                    <div className="w-2 h-2 rounded-full bg-accent mt-2 flex-shrink-0" data-id="element-186" data-mp="2pbj8e5m6lf6d" />
                    <span data-id="element-187" data-mp="2u9ui8gch7pol">
                      <strong data-id="element-188" data-mp="2u91jo2no86hj">Přímo v objektu:</strong> supermarket s plochou 1
                      000 m² (24/7/365), další obchody, lékárna, lékařské
                      ordinace, sauna/masáže, fitness
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-189" data-mp="26ki9tioz3lnc">
                    <div className="w-2 h-2 rounded-full bg-accent mt-2 flex-shrink-0" data-id="element-190" data-mp="26m34r9f796lq" />
                    <span data-id="element-191" data-mp="2bkeelk5hvh3y">
                      <strong data-id="element-192" data-mp="2bjuz0a3bh4t3">V okruhu stovek metrů:</strong> pošta, bankomat,
                      obecní úřad, nová ZŠ, školky, autobusové zastávky PID,
                      sportovní zázemí – temperovaná tenisová hala, tělocvičny,
                      2 travnatá fotbalová hřiště, lesopark, rybník
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-193" data-mp="2zwztldrukc92">
                    <div className="w-2 h-2 rounded-full bg-accent mt-2 flex-shrink-0" data-id="element-194" data-mp="2zzm0db6wynq8" />
                    <span data-id="element-195" data-mp="2v4ggehx2nj4s">
                      <strong data-id="element-196" data-mp="2q7q1vz0x0vlh">V okruhu jednotek km:</strong> multifunkční
                      sportovní hala Hlubočinka 3 km, SUNNY Canadian
                      MŠ/ZŠ/Gymnázium 5 km, Da VINCI school – Dolní Břežany 7
                      km, IKEM Praha 10 km, Prague British International School
                      10 km, přírodní i kryté jízdárny
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex flex-wrap gap-4" data-id="element-197" data-mp="27af30fj7446k">
              <div className="flex items-center gap-2 bg-base-cream px-4 py-2 rounded-full text-sm font-medium text-primary" data-id="element-198" data-mp="agu1phr8j6uj">
                <CarIcon className="w-4 h-4" data-id="element-199" data-mp="5iiu7doex8fh" />
                Pražský okruh - 2 km
              </div>
              <div className="flex items-center gap-2 bg-base-cream px-4 py-2 rounded-full text-sm font-medium text-primary" data-id="element-200" data-mp="czyvdn6nqeuf">
                <TrainIcon className="w-4 h-4" data-id="element-201" data-mp="hxqjs783fitv" />
                Metro Opatov - 12 km
              </div>
              <div className="flex items-center gap-2 bg-base-cream px-4 py-2 rounded-full text-sm font-medium text-primary" data-id="element-202" data-mp="msw5b4xl2vhf">
                <MapPinIcon className="w-4 h-4" data-id="element-203" data-mp="3q7ih5tl2jnw1" />
                Aquapalace Čestlice - 13 km
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative h-[500px] w-full bg-base-cream rounded-2xl border border-primary/10 flex items-center justify-center p-8 overflow-hidden shadow-xl" data-id="element-204" data-mp="3v6llfbt85q2y">
            {/* Background Image */}
            <img src="https://cdn.magicpatterns.com/uploads/pBPDF5SFGUcvhqAVU9DGHy/18.png" alt="Nádvoří Svatý Václav" className="absolute inset-0 w-full h-full object-cover" data-id="element-205" data-mp="3bhajxk3tae3d" />

            {/* Overlay to ensure card readability */}
            <div className="absolute inset-0 bg-primary/10" data-id="element-206" data-mp="2xq5qx0uy8k20"></div>

            {/* Stylized Map Placeholder Pattern */}
            <div className="absolute inset-0 opacity-20 mix-blend-multiply" style={{
            backgroundImage: 'radial-gradient(#4A4543 1px, transparent 1px)',
            backgroundSize: '20px 20px'
          }} data-id="element-207" data-mp="2st5k2nq9zd9u"></div>

            <div className="relative z-10 bg-white/95 backdrop-blur-sm p-8 rounded-xl shadow-2xl max-w-sm text-center border-t-4 border-primary" data-id="element-208" data-mp="2e1wpe07in1pu">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-209" data-mp="29zjt02ensg5q">
                <MapPinIcon className="w-8 h-8 text-primary" data-id="element-210" data-mp="24nw9b8il0z2e" />
              </div>
              <h3 className="font-heading text-2xl font-bold text-base-dark mb-2" data-id="element-211" data-mp="24pzamop6qemf">
                Svatý Václav
              </h3>
              <p className="text-base-gray mb-4" data-id="element-212" data-mp="1uxtineyxnx78">
                Dolní Jirčany
                <br data-id="element-213" data-mp="2inxirccwxeth" />
                Praha-západ
              </p>
              <div className="h-px w-full bg-gray-100 my-4" data-id="element-214" data-mp="2iop31r127q4g" />
              <a href={MAP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-accent hover:text-accent-hover font-medium transition-colors" data-id="element-215" data-mp="2nlz3s2twfo7l">
                Zobrazit na mapě
                <ExternalLinkIcon className="w-4 h-4" data-id="element-216" data-mp="x9jbymo7cl9s" />
              </a>
            </div>

            {/* Decorative elements */}
            <div className="absolute top-10 right-10 w-32 h-32 bg-primary/20 rounded-full blur-2xl" data-id="element-217" data-mp="12ayx0eqdqrs6"></div>
            <div className="absolute bottom-10 left-10 w-40 h-40 bg-accent/20 rounded-full blur-2xl" data-id="element-218" data-mp="jh1yrxzsh39u"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}